export default __webpack_public_path__ + "assets/credit_card.pdf";